/* import components */
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import BadgeOutline from './BadgeOutline';
import BadgeFill from './BadgeFill';
import LocationIcon from './icons/LocationIcon';
import ProfilePicture from './ProfilePicture';

/* import services */
import { getDateTime, getTripPrice } from '../utils/utils';

const TripSummary = (props) => {

    const trip = props.trip;

    return (
        <>
            <Card style={{ padding: "0", marginTop:"20px" }}>
                <ListGroup variant="flush">
                    <ListGroup.Item style={{ padding: "15px", display: "flex", justifyContent: "space-between"}}>
                        <div>
                            <Card.Title 
                                className="pink font-bold" 
                                style={{ fontSize: "12px" }}>
                                    Trip {trip.status}
                            </Card.Title>
                            <Card.Subtitle className="grey topics">
                                {getDateTime(trip.rideStartTime, "utc")}
                            </Card.Subtitle>
                        </div>
                        <div style={{ display: "flex" }}>
                            {trip.serviceType === "RydeFLASH" || trip.serviceType === "RydePOOL" ? 
                            <BadgeFill serviceType={trip.serviceType} title={trip.numberPassenger + " Pax"} /> 
                            : <></>}&nbsp;
                            <BadgeOutline title={trip.serviceType} />
                        </div>
                    </ListGroup.Item>
                        <div className="alignImageText" style={{ padding:"15px", display:"flex"}}>
                            <div style={{ marginTop: "auto", marginBottom: "auto", paddingRight: "15px" }}>
                                <ProfilePicture trip={trip} />

                            </div>
                            <div className="alignImageText" style={{ width:"100%", justifyContent: "space-between"}}>
                                <Card.Title 
                                    className="grey font-semibold"
                                    style={{ fontSize: "16px"}}>
                                        {trip.driverInfo?.firstName || trip.riderInfo?.firstName}
                                </Card.Title>
                                <div className="alignTextDiffSize">
                                    <Card.Title 
                                        className="grey font-semibold"
                                        style={{ fontSize: "16px"}}>
                                            S$ 
                                    </Card.Title>&nbsp;
                                    <Card.Title 
                                        className="grey font-semibold"
                                        style={{ fontSize: "21px"}}>
                                            {getTripPrice(trip.price)}
                                    </Card.Title>
                                </div>
                            </div>
                        </div>
                        <div style={{ paddingLeft: "20px"}}>
                            <Card.Title 
                                className="trip-route font-semibold"
                                style={{ fontSize: "16px" }}>
                                    Trip Route
                            </Card.Title>

                            <div style={{ display: "flex" }}>
                                <div style={{ display: "flex", flexDirection: "column"}}>
                                    <span className="colored-circle"/>
                                    <span className="grey-dots" style={{  margin: "12px 6px 0 6px" }}/>
                                    <span className="grey-dots"/>
                                    <span className="grey-dots"/>
                                    <span className="grey-dots" style={{  margin: "6px" }}/>
                                </div>
                                <p style={{ fontSize: "14px", color: "#2E3849", padding: "0 5px", margin: "0" }}>
                                    {trip.startPlace}
                                </p>
                            </div>
                            
                            {/* If there is >1 stop: */}
                            {trip.additionalStops?.length > 0 ? 
                                trip.additionalStops.map((addTrip,i) => 
                                <div key={i} style={{ display: "flex" }}>
                                    <div style={{ display: "flex", flexDirection: "column"}}>
                                        <LocationIcon />
                                        <span className="grey-dots" style={{  margin: "6px 6px 0 6px" }}/>
                                        <span className="grey-dots"/>
                                        <span className="grey-dots"/>
                                        <span className="grey-dots" style={{  margin: "6px" }}/>
                                        
                                    </div>
                                    <p style={{ fontSize: "14px", color: "#2E3849", padding: "0 5px", margin: "0" }}>
                                        {addTrip.address}
                                    </p>
                                </div> )
                                : <></>}

                            <div style={{ display: "flex",  marginBottom: "1rem" }}>
                                <LocationIcon />
                                <p style={{ fontSize: "14px", color: "#2E3849", padding: "0 5px", width: "100%" }}>
                                    {trip.endPlace}
                                </p>
                            </div>
                        </div>
                    <ListGroup.Item style={{padding:"0"}}/>
                </ListGroup>
            </Card>
        </>
    )
}

export default TripSummary;